import { FC } from 'react';
import { AuthUser } from '../../lib/services/auth.service';
import { Avatar, Box } from '@mui/material';
import { getInitials } from '../../lib/helpers';
import Icon from '../icon';
import { createUseStyles } from 'react-jss';

interface Props {
  user: AuthUser;
}

const useStyles = createUseStyles({
  userBadge: {
    backgroundColor: 'none',
  },
});

const UserBadge: FC<Props> = ({ user }) => {
  const styles = useStyles();
  const { displayName, photoURL } = user;
  const username = displayName || '';
  const hasPhoto = Boolean(photoURL);
  const initials = getInitials(username);
  const hasName = !!initials;

  return (
    <Box>
      {hasPhoto && (
        <Avatar alt={username} src={photoURL || ''} imgProps={{ referrerPolicy: 'no-referrer' }} />
      )}
      {!hasPhoto && hasName && <Avatar className={styles.userBadge}>{initials}</Avatar>}
      {!hasPhoto && !hasName && (
        <Avatar className={styles.userBadge}>
          <Icon name="person" color="white" />
        </Avatar>
      )}
    </Box>
  );
};

export default UserBadge;
